import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { getUser } from '../../utils/tokens';

const ResourceRow = ({ resource, category, isDragging }) => {
	let navigate = useNavigate();

	const sortId = category + ':' + resource.idx.toString();
	const { setNodeRef, attributes, listeners, transform, transition } = useSortable({
		id: sortId,
	});

	const [enabled, setEnabled] = useState(resource.enabled);
	const [isGlobal, setIsGlobal] = useState(resource.global);
	const [name, setName] = useState(null);
	const [isAdmin, setIsAdmin] = useState(false);
	const currentUser = getUser();

	useEffect(() => {
		setEnabled(resource.enabled);
		setIsGlobal(resource.global);

		if (resource.type === 'ATTACHMENT') {
			if (resource.resourceAttachments && resource.resourceAttachments.length > 0) {
				setName(resource.resourceAttachments[0].label);
			}
		} else if (resource.type === 'LINK') {
			if (resource.resourceLinks && resource.resourceLinks.length > 0) {
				setName(resource.resourceLinks[0].name);
			}
		} else if (resource.type === 'INLINE') {
			setName(resource.name);
		}

		if (currentUser.scope) {
			if (currentUser.scope.includes('admin')) {
				setIsAdmin(true);
			}
		}
	}, [resource]);

	function handleEditClick(id) {
		navigate('edit/' + id);
	}

	const style = {
		transition,
		transform: CSS.Transform.toString(transform),
	};

	return (
		<ResourceTR
			id={sortId}
			title={name}
			resource={resource}
			isDragging={isDragging}
			nodeRef={setNodeRef}
			style={style}
			onClick={handleEditClick}
			key={resource.id}
			className="group hover:bg-indigo-50 hover:cursor-pointer">
			<td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-semibold text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
				{name}
				<dl className="font-normal lg:hidden">
					<dt className="sr-only">Title</dt>
					<dd className="mt-1 truncate">
						<span>Type:&nbsp;</span>
						{resource.type}
					</dd>
					<dt className="sr-only">Enabled</dt>
					<dd className="mt-1 truncate">
						{enabled && <span>Status:&nbsp;Enabled</span>}
						{!enabled && <span>Status:&nbsp;Disabled</span>}
					</dd>

					{isAdmin && (
						<>
							<dt className="sr-only">Global</dt>
							<dd className="mt-1 truncate">
								{isGlobal && <span>Global:&nbsp;Global</span>}
								{!isGlobal && <span>Status:&nbsp;Client</span>}
							</dd>
						</>
					)}
				</dl>
			</td>

			<td className="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">{resource.type}</td>
			<td className="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
				{enabled && <span>Enabled</span>}
				{!enabled && <span className="text-black">Disabled</span>}
			</td>
			{isAdmin && (
				<>
					<td className="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
						{isGlobal && <span>Global</span>}
						{!isGlobal && <span>Client</span>}
					</td>
				</>
			)}
			<td className="content-center">
				{resource.resourceCategory && (
					<div {...attributes} {...listeners} className="invisible group-hover:visible">
						<svg viewBox="0 0 20 20" width="12">
							<path d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z"></path>
						</svg>
					</div>
				)}
			</td>
		</ResourceTR>
	);
};

const ResourceTR = ({ isDragging, ...props }) => {
	return (
		<>
			{isDragging ? (
				<tr key={props.resource.id} className="group hover:bg-indigo-50 hover:cursor-pointer">
					<td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:w-auto sm:max-w-none sm:pl-6">
						{props.title}
					</td>
				</tr>
			) : (
				<tr
					id={props.id}
					ref={props.nodeRef}
					style={props.style}
					onClick={() => {
						props.onClick(props.resource.id);
					}}
					key={props.resource.id}
					className="group hover:bg-indigo-50 hover:cursor-pointer">
					{props.children}
				</tr>
			)}
		</>
	);
};
export default ResourceRow;
